/**
 * Redimensiona una foto en el propio movil antes de subirla.
 *
 * Las camaras de movil sacan ficheros de 4-8 MB que no aportan nada en una foto
 * de obra y tardan una eternidad con cobertura mala. Se reduce el lado mayor y
 * se recomprime a JPEG.
 */
const MAX_SIDE = 1600;
const QUALITY = 0.8;

export default function resizeImage(file, maxSide = MAX_SIDE, quality = QUALITY) {
  return new Promise((resolve) => {
    // Los formatos que el navegador no sabe pintar (HEIC de iPhone) se suben tal cual
    if (!file.type.startsWith('image/') || file.type === 'image/heic' || file.type === 'image/heif') {
      resolve(file);
      return;
    }

    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      if (scale === 1 && file.size < 1024 * 1024) {
        resolve(file);
        return;
      }
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(file);   // si algo falla, se sube el original
            return;
          }
          resolve(new File([blob], 'foto.jpg', { type: 'image/jpeg' }));
        },
        'image/jpeg',
        quality,
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };

    img.src = url;
  });
}
